import NavBar from './NavBar'

const Policies = () => {
  return (
    <div>
      <NavBar />
      <h1 className="mb-4 text-center text-[24px] font-extrabold lg:text-[48px]">
        Policies
      </h1>
      <div className="mx-8 my-4 space-y-4 text-[14px] leading-relaxed text-black lg:mx-80 lg:my-8 lg:text-[16px]">
        <p>
          {`As required by the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021 (as amended) ("IT Rules"), here is your quarterly reminder of Askk policies that govern our platform. We are committed to providing amazing social experiences for our users. Our policies provide the dos and don’ts on Askk and the steps we take in case of violation of our policies.`}
        </p>
        <p>
          {`As an intermediary, we remind you to comply with all applicable laws, including the Information Technology Act, 2000 and the IT Rules, while accessing our platform. To enhance your awareness of the consequences of non-compliance with the IT Rules, our policy also includes an illustrative and indicative list of applicable regulations.`}
        </p>
        <p>{`Thank you for being a part of our community!`}</p>
      </div>
      <div className="flex flex-col items-center">
        <a
          href="/terms"
          className="mt-4 text-[14px] text-black underline lg:mr-[16px] lg:mt-0"
        >
          Terms & Conditions
        </a>
        <a
          href="/privacy"
          className="mt-4 text-[14px] text-black underline lg:mr-[16px] lg:mt-0"
        >
          Privacy Policy
        </a>
        <a
          href="/community"
          className="mt-4 text-[14px] text-black underline lg:mr-[16px] lg:mt-0"
        >
          Community & Content Guidelines
        </a>
        <a
          href="/coins-policy"
          className="mt-4 text-[14px] text-black underline lg:mr-[16px] lg:mt-0"
        >
          Coins Policy
        </a>
        <a
          href="/guide-terms"
          className="mt-4 text-[14px] text-black underline lg:mr-[16px] lg:mt-0"
        >
          Guide Terms
        </a>
        <a
          href="/delete-account-faq"
          className="mt-4 text-[14px] text-black underline lg:mr-[16px] lg:mt-0"
        >
          Delete Account FAQ
        </a>
      </div>
    </div>
  )
}

export default Policies
